<template>
  <div class="good">
    <div class="bg">
      <div class="container">
        <div class="title">
          <p class="item">{{shopname}}</p>
          <p class="item">表白商店</p>
        </div>
        <div class="goodslist">
          <ul class="infos">
            <li class="lis" v-for="(item,index) in goodsList" :key="index">
              <div class="image">
                <img :src="item.goodsImg" alt>
              </div>
              <div class="right">
                <p class="goodsname">{{item.goodsName}}</p>
                <div class="info">
                  <span class="price">
                    <span></span>
                    {{item.price}}
                  </span>
                  <p class="btn">
                    <img src="../../../assets/images/active/goumai.png" alt>
                    <span @click="buygoods(item)">购买</span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      otheruserguid:'',
      url: "",
      goodsList: [],
      goodsId: "",
      shopname: ""
    };
  },
  created() { 
     document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
    if(this.$route.params.id){
      this.$store.dispatch('OtherUserGuid',this.$route.params.id)//将数据存储在vuex 中
      localStorage.setItem("otheruserguid",this.$route.params.id)//将数据存储在本地
      this.shopid = this.$route.params.id; //地址栏获得店铺id
    }else{
      this.shopid = this.$store.state.otheruserguid
      if(!this.shopid){
        this.shopid = localStorage.getItem("otheruserguid")
      }
    }
    if(!this.$store.state.userguid){
      this.$router.push({ path: "/login" });
      return
    }
    this.getBuyList();
    
  },
  methods: {
    buygoods(item) {
      this.$router.push({
        path: "/buy",
        query: {
          goodsId: item.goodsId,
          shopname: this.shopname,
          goodsimg: item.goodsImg,
          goodsname: item.goodsName,
          shopid: this.shopid //传递店主的店铺标识 shoopid
        }
      });
    },
    getBuyList() {
      axios.post(this.$interfaces.getUserActivityLoveShop, {
          token: this.$store.state.token,
          userGuid: this.$store.state.userguid,
          ownerUserGuid: this.shopid,
        })
        .then(res => {
          if(res.data.code == 400){
            this.$router.push({ path: "/login" });
            return
          }
          
          this.goodsList = res.data.data.goodsList;
          this.shopname = res.data.data.shopName;
        }).catch(err=>{
        })
    }
  }
};
</script>

<style scoped>
.good {
  width: 100%;
  height: 100%;
}
.good .bg {
  background: url("../../../assets/images/active/bg/bgmyhome.png") no-repeat
    left top;
  background-size: cover;
  height: 33.35rem;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
}
.good .bg .container {
  padding-left: 2.125rem;
  padding-right: 2.125rem;
  position: absolute;
  top: 2.975rem;
  text-align: center;
}
.good .bg .container .title {
  width: 14.5rem;
  text-align: center;
  font-size: 0.95rem;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: rgba(255, 57, 113, 1);
  margin-bottom: 1.475rem;
}
.good .bg .container .goodslist .infos .lis {
  position: relative;
  width: 16rem;
  height: 4.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.5rem;
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  display: flex;
}
.good .bg .container .goodslist .infos .lis:last-child {
  margin-bottom: 0;
}
.good .bg .container .goodslist .infos .lis .image {
  flex: 0 0 3rem;
  width: 3rem;
  height: 3rem;
  border: 0.025rem solid #ccc;
  margin-right: 1rem;
}
.good .bg .container .goodslist .infos .lis .image img {
  width: 100%;
  height: 100%;
}

.good .bg .container .goodslist .infos .lis .right .goodsname {
  position: absolute;
  text-align: left;
  height: 1.25rem;
  /* line-height: 1.25rem; */
  color: rgba(117, 86, 98, 1);
  font-size: 0.7rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  /* border-bottom:0.025rem solid #ccc */
}

.good .bg .container .goodslist .infos .lis .right .info {
  position: absolute;
  bottom: 0.75rem;
  padding-top: 1.25rem;
  height: 1.3rem;
  background: yellow;
}
.good .bg .container .goodslist .infos .lis .right .info .price {
  position: absolute;
  bottom: 0;
  font-size: 1.05rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(255, 66, 118, 1);
  line-height: 0.7rem;
}
.good .bg .container .goodslist .infos .lis .right .info .price span {
  color: rgba(255, 66, 118, 1);
  font-size: 0.6rem;
}
.good .bg .container .goodslist .infos .lis .right .info .btn {
  position: absolute;
  left: 5.625rem;
  bottom: 0;
  width: 4.6rem;
  height: 1.3rem;
}
.good .bg .container .goodslist .infos .lis .right .info .btn span {
  position: absolute;
  left: 0;
  bottom: 0.3rem;
  width: 4.6rem;
  height: 1.3rem;

  font-size: 0.6rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.good .bg .container .goodslist .infos .lis .right .info .btn img {
  width: 100%;
  height: 100%;
}
.good .bg .btn {
  position: absolute;
  bottom: 1.65rem;
  width: 16rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  color: white;
  font-size: 1rem;
}
.good .bg .btn .mocen {
  position: absolute;
  width: 16rem;
  height: 3rem;
  left: 0;
  top: 0;
  /* background:pink; */
}
.good .bg .btn .font {
  position: absolute;
  top: 0;
  left: 0;
  width: 16rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  color: white;
  font-size: 1rem;
}
.good .bg .btn img {
  width: 100%;
  height: 100%;
}
</style>








// WEBPACK FOOTER //
// src/components/active/view/otherhome.vue